import React from "react";
import { ButtonWrapper } from "./styled";

type ButtonProps = {
  color?: string;
  backgroundColor?: string;
  disabled?: boolean;
  type?: "submit" | "button";
  onClick?: () => void;
  children: any;
  title?: string;
  hasRecurrence?: string;
  minWidth?: number | string;
};

const ButtonRound = ({
  color,
  backgroundColor,
  disabled,
  type,
  children,
  onClick,
  title,
  hasRecurrence,
  minWidth,
}: ButtonProps): JSX.Element => (
  <ButtonWrapper
    type={type}
    backgroundColor={backgroundColor}
    color={color}
    disabled={disabled}
    onClick={onClick}
    title={title}
    hasRecurrence={hasRecurrence}
    minWidth={minWidth}
  >
    {children}
  </ButtonWrapper>
);
export default ButtonRound;
